import { BedDouble, Bath, Ruler } from 'lucide-react';
import { formatPrice } from '@/utils/format';

export function SelectedListingPreview({ listing }) {
  if (!listing) return null;
  const photo = listing.photos?.[0];
  return (
    <div className="flex gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="h-20 w-28 shrink-0 overflow-hidden rounded-xl bg-slate-100">
        {photo ? <img src={photo} alt={listing.address} className="h-full w-full object-cover" /> : null}
      </div>
      <div className="min-w-0">
        <p className="truncate font-semibold text-slate-900">{listing.streetAddress || listing.address}</p>
        <p className="truncate text-sm text-slate-500">{[listing.city, listing.state].filter(Boolean).join(', ')} {listing.zip}</p>
        <p className="mt-1 text-lg font-bold text-blue-700">{formatPrice(listing.price)}</p>
        <div className="mt-1 flex items-center gap-3 text-xs text-slate-500">
          <span className="flex items-center gap-1"><BedDouble size={13} />{listing.beds ?? '—'} bd</span>
          <span className="flex items-center gap-1"><Bath size={13} />{listing.baths ?? '—'} ba</span>
          <span className="flex items-center gap-1"><Ruler size={13} />{listing.sqft ? `${listing.sqft.toLocaleString()} sqft` : '—'}</span>
        </div>
      </div>
    </div>
  );
}
